import _ from 'lodash'
import inflationService from "data/inflation"
import multifamilyService from "data/multifamily"
import propertyService from 'data/property.ts'

// TODO Needs better schema (NBS)

type Update = {
  applied: object[] // migration config
  property: object // updated property object.  NBS
  rowsAffected: number
  saveChanges: Function // depricated since migrations are automatically applied now
  updated: { // updated dependent objects.  NBS
    increase: object[]
    inflation: object[]
    marketlease: object[]
    property: object[]
    rentroll: object[]
  }
} /* | {} */

const dependents = {
  // increase: TBD,
  inflation: inflationService.fetchInflation,
  // marketlease: TBD,
  multifamily: multifamilyService.fetchByPropertyId,
  // rentroll: TBD,
}

/**
 * updatedServices
 *
 * For updated properties and their dependents, use the appropriate service to refetch data.
 * @param updates
 */
export function updatedServices(updates: Update|Update[]) {
  const _updates = _.isArray(updates) ? updates : [updates]
  const updated_properties = _.filter(_updates, u => !_.isEmpty(_.get(u, 'updated.property')))
  if (!_.isEmpty(updated_properties)) {
    const folderids = _.uniq(_.map(updated_properties, 'property.folderid'))
    for(let folderid of folderids)
      propertyService.fetchByFolderId(folderid)
  }

  const update = _.find(_updates, {property: {propertyid: _.get(propertyService.get(), "propertyid")}})
  if (_.isEmpty(update)) return
  for(let key in dependents) {
    if (_.isEmpty(update.updated[key])) continue
    dependents[key](update.property.propertyid)
  }
}